// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1aFSv","empty":"ModalGraph_empty__115tc"};